<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { ChevronDownIcon } from "@radix-icons/vue"
import {
	AccordionHeader,
	AccordionTrigger,
	type AccordionTriggerProps,
} from "radix-vue"
import { useClass } from "~/composables/local/cn-class"

const { class: rawClass, ...props } = defineProps<AccordionTriggerProps & { class?: HTMLAttributes["class"] }>()

const className = useClass(
	"flex flex-1 items-center justify-between py-4 text-sm font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
	() => rawClass,
)
</script>

<template>
	<AccordionHeader class="flex">
		<AccordionTrigger
			v-bind="props"
			:class="className">
			<slot />

			<slot name="icon">
				<ChevronDownIcon
					class="size-4 shrink-0 text-muted-foreground transition-transform duration-200" />
			</slot>
		</AccordionTrigger>
	</AccordionHeader>
</template>
